<template>
  <div class="modal">
    <div class="modal-content">
      <div @click="$emit('close')" class="close">X</div>
      <h5>Réinitialise ton mot de passe </h5>
      <div v-if="!showSuccess">
        <p></p>
        <form @submit.prevent>
          <v-text-field  label="email"  prepend-icon="mdi-email"  v-model.trim="email" type="email" />
        </form>
        <p v-if="errorMsg !== ''" class="error">{{ errorMsg }}</p>
        <v-btn color="info"  @click="resetPassword()" class="button">Envoyer</v-btn>
      </div>
      <p v-else>Ca marche ! Vérifie ta boite mail.</p>
    </div>
  </div>
</template>

<script>
import { auth } from '@/firebase'

export default {
  data () {
    return {
      email: '',
      showSuccess: false,
      errorMsg: ''
    }
  },
  methods: {
    async resetPassword () {
      this.errorMsg = ''

      try {
        await auth.sendPasswordResetEmail(this.email)
        this.showSuccess = true
      } catch (err) {
        this.errorMsg = err.message
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/PasswordReset.vue